<template>
  <div class="backup-item">
    <div
      class="tag"
      v-if="tag"
      @click="clickTag"
    >{{tag}}</div>
    <div class="time">{{toDatetimeStr(item.time)}}</div>
    <div class="btns">
      <el-tooltip
        effect="dark"
        content="预览"
        placement="bottom"
      >
        <div
          class="btn btn-preview"
          @click="preview"
        ></div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        content="恢复"
        placement="bottom"
      >
        <div
          class="btn btn-revert"
          @click="revert"
        ></div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import Datetime from '@/plugins/Datetime';

export default {
  props: {
    item: {
      type: Object,
      default () {
        return {
          time: new Date('2020-4-07 14:29:00')
        }
      }
    },
    tag: { type: String, default: '' }
  },
  data () {
    return {

    }
  },
  methods: {
    toDatetimeStr (date) {
      if (!date) {
        date = new Date();
      }
      return new Datetime(date).toDatetimeStr();
    },
    preview () {
      this.$emit('preview', this.item);
    },
    revert () {
      if (this.tag) {
        this.clickTag();
        return;
      }
      this.$emit('revert', this.item);
    },
    clickTag () {
      this.$emit('clickTag');
    }
  }
}
</script>

<style lang="scss" scoped>
.backup-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 226px;
  height: 44px;
  background: #fafaff;
  border-radius: 4px;
  padding: 10px;
  &:hover {
    background: #f2f3f7;
    & .btns {
      display: flex;
    }
    & > .tag {
      display: block;
    }
  }
}
.btn {
  width: 12px;
  height: 12px;
  cursor: pointer;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.btns {
  display: none;
  align-items: center;
  justify-content: center;
  & .btn-preview {
    width: 15px;
    height: 15px;
    margin-right: 6px;
    background-image: url(../../../static/svg/versionControl/eye.svg);
    &:hover {
      background-image: url(../../../static/svg/versionControl/eye-active.svg);
    }
  }
  & .btn-revert {
    margin-right: 6px;
    background-image: url(../../../static/svg/versionControl/revert.svg);
    &:hover {
      background-image: url(../../../static/svg/versionControl/revert-active.svg);
    }
  }
}
.tag {
  display: none;
  position: absolute;
  left: -7px;
  top: -10px;
  width: 103px;
  height: 23px;
  line-height: 23px;
  background: #303030;
  border-radius: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/versionControl/backupItem.vue